// extracted by mini-css-extract-plugin
export default {"integrationButton":"src-common-components-integrations-settings-integrations-settings-module__integrationButton--1ZqX-"};